import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle, Shield, Award } from "lucide-react";

export default function CosmeticSurgery() {
  const { t } = useTranslation();

  return (
    <div className="pt-20">
      <Helmet>
        <title>Cosmetic & Plastic Surgery in Turkey | Monimek</title>
        <meta name="description" content="Safe, board-certified plastic surgery in Turkey. Nose jobs (rhinoplasty), tummy tucks, mommy makeovers, and BBLs with premium JCI-accredited hospitals." />
        <link rel="canonical" href="https://www.monizmek.com/treatments/cosmetic-surgery" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalProcedure",
              "name": "Cosmetic Surgery",
              "description": "Premium plastic surgery including Rhinoplasty, Breast Augmentation, and Tummy Tucks at JCI-accredited clinics in Turkey.",
              "procedureType": "Surgical",
              "provider": {
                "@type": "MedicalBusiness",
                "name": "Monimek Partner Clinics",
                "address": {
                  "@type": "PostalAddress",
                  "addressCountry": "Turkey",
                  "addressLocality": "Istanbul"
                }
              },
              "offers": {
                "@type": "AggregateOffer",
                "priceCurrency": "USD",
                "lowPrice": "2500",
                "highPrice": "6000",
                "offerCount": "5"
              }
            }
          `}
        </script>
      </Helmet>

      <section className="bg-[#F8FAFC] py-20">
        <div className="max-w-[1200px] mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl sm:text-5xl font-black text-[#0B3C5D] font-outfit mb-6">Cosmetic Surgery in Turkey</h1>
            <p className="text-lg text-[#6B7280] mb-8">
              Enhance your natural beauty with world-renowned plastic surgeons in Turkey. From expert Rhinoplasty (Nose Jobs) to comprehensive Mommy Makeovers, Monimek connects you with top-tier aesthetic clinics prioritizing safety, symmetry, and rapid recovery.
            </p>
            <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 bg-[#3FA7D6] text-white font-bold rounded-full hover:bg-[#0B3C5D] transition-colors">
              Request Your Free Consultation <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
          <div>
            <img src="https://images.pexels.com/photos/3259813/pexels-photo-3259813.jpeg?auto=compress&cs=tinysrgb&w=800" alt="Cosmetic Plastic Surgery Hospital Turkey" className="rounded-3xl shadow-xl w-full h-[400px] object-cover" />
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-[1000px] mx-auto px-6">
          <h2 className="text-3xl font-bold text-[#0B3C5D] font-outfit mb-8 text-center">Popular Aesthetic Procedures</h2>
          <div className="grid sm:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
              <Award className="w-10 h-10 text-[#3FA7D6] mb-4" />
              <h3 className="font-bold text-lg mb-2">Rhinoplasty</h3>
              <p className="text-[#6B7280] text-sm">Turkish surgeons are globally famous for advanced Piezo (ultrasonic) nose jobs with minimal swelling and perfect results.</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
              <Shield className="w-10 h-10 text-[#3FA7D6] mb-4" />
              <h3 className="font-bold text-lg mb-2">Body Contouring</h3>
              <p className="text-[#6B7280] text-sm">Vaser liposuction, tummy tucks, and Brazilian Butt Lifts (BBL) performed in elite, fully-equipped JCI hospitals.</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
              <CheckCircle className="w-10 h-10 text-[#3FA7D6] mb-4" />
              <h3 className="font-bold text-lg mb-2">Breast Surgery</h3>
              <p className="text-[#6B7280] text-sm">Augmentation, lifts, and reductions using FDA-approved implants exclusively (Motiva, Mentor).</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
